import { gql, useLazyQuery } from "@apollo/client";
export const QUERY_GET_SVN_CONTENT = gql`
  query getSpmRePaths(
    $username: String!
    $encryptedPassword: String!
    $spmReFolder: String!
    $spmReRevision: String
    $spmRePath: String
  ) {
    getSpmRePaths(
      input: {
        username: $username
        encryptedPassword: $encryptedPassword
        spmReFolder: $spmReFolder
        spmReRevision: $spmReRevision
        spmRePath: $spmRePath
      }
    ) {
      spmRePaths {
        name
        size
      }
    }
  }
`;

export function useGetSvnContentQuery() {
  const [getSpmRePaths, { error, loading, data }] = useLazyQuery(
    QUERY_GET_SVN_CONTENT,
    { fetchPolicy: "no-cache" }
  );

  return {
    getSpmRePaths,
    error,
    loading,
    data
  };
}
